export const dataScienceReasons = [

    {
        title: "Learn Practical Data Science Skills",

        description: (
            <>
                Build practical knowledge across{" "}
                <span className="tech-tag">
                    Python
                </span>

                <span className="tech-tag">
                    SQL
                </span>

                <span className="tech-tag">
                    Data Analysis
                </span>

                <span className="tech-tag">
                    Machine Learning
                </span>
                {" "}and other Data Science technologies.
            </>
        ),
    },


    {
        title: "Work with Real-World Data",

        description: (
            <>
                Develop experience working with data through{" "}
                <span className="highlight">
                    data handling, manipulation, analysis and visualization
                </span>
                {" "}concepts.
            </>
        ),
    },


    {
        title: "Build Machine Learning Knowledge",

        description: (
            <>
                Learn Machine Learning foundations and{" "}
                <span className="highlight-blue">
                    unsupervised Machine Learning
                </span>
                {" "}as part of the Data Science learning path.
            </>
        ),
    },


    {
        title: "Learn Generative AI",

        description: (
            <>
                Understand Generative AI concepts and explore how{" "}
                <span className="highlight">
                    AI technologies can be applied to Data Science
                </span>
                {" "}workflows.
            </>
        ),
    },


    {
        title: "Develop Data Visualization Skills",

        description: (
            <>
                Learn how to work with data and communicate analytical
                information through{" "}
                <span className="highlight-blue">
                    data visualization and BI storytelling
                </span>.
            </>
        ),
    },


    {
        title: "Understand Advanced Analytics",

        description: (
            <>
                Progress from foundational concepts into{" "}
                <span className="tech-tag">
                    Advanced Analytics
                </span>

                <span className="tech-tag">
                    Statistics
                </span>

                <span className="tech-tag">
                    Time Series
                </span>
                {" "}and related topics.
            </>
        ),
    },


    {
        title: "Learn Big Data Concepts",

        description: (
            <>
                Understand{" "}
                <span className="highlight">
                    Big Data, SQL and Business Intelligence
                </span>
                {" "}as part of the broader Data Science curriculum.
            </>
        ),
    },


    {
        title: "Build a Capstone Project",

        description: (
            <>
                Apply your learning through{" "}
                <span className="highlight-blue">
                    capstone preparation, project development and
                    presentation
                </span>.
            </>
        ),
    },


    {
        title: "Explore Multiple Career Paths",

        description: (
            <>
                The course content relates to roles including{" "}
                <span className="tech-tag">
                    Data Scientist
                </span>

                <span className="tech-tag">
                    Data Analytics
                </span>

                <span className="tech-tag">
                    AI Engineering
                </span>

                <span className="tech-tag">
                    Python Developer
                </span>.
            </>
        ),
    },


    {
        title: "Learn from Professionals",

        description: (
            <>
                The course is presented as training designed by
                professionals with experience in{" "}
                <span className="highlight">
                    Artificial Intelligence, Machine Learning and
                    Deep Learning
                </span>.
            </>
        ),
    },

];